import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#5b8def',
      dark: '#3d6dcc',
      light: '#8fb4ff',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f87171',
      dark: '#dc3545',
      light: '#fca5a5',
      contrastText: '#ffffff',
    },
    success: {
      main: '#34d399',
      dark: '#059669',
      light: '#6ee7b7',
    },
    error: {
      main: '#f87171',
    },
    warning: {
      main: '#fbbf24',
    },
    info: {
      main: '#60a5fa',
    },
    background: {
      default: '#0f1219',
      paper: '#1a1f2e',
    },
    text: {
      primary: '#e8eaed',
      secondary: '#9aa3b2',
    },
    divider: '#2d3548',
    action: {
      hover: 'rgba(255, 255, 255, 0.06)',
      selected: 'rgba(255, 255, 255, 0.12)',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h5: {
      fontSize: '1.35rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1.1rem',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#0f1219',
          color: '#e8eaed',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#1a1f2e',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #2d3548',
        },
        head: {
          backgroundColor: '#232936',
          color: '#c5cad3',
          fontWeight: 600,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.03)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3d4556',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#5b8def',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3548',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#9aa3b2',
          '&.Mui-selected': {
            color: '#f87171',
          },
        },
      },
    },
  },
});

export default theme;
